var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0224 40.0039C15.4011 40.0001 10.9232 38.401 7.34707 35.4774C3.77089 32.5539 1.31624 28.4855 0.398851 23.9613C-0.518541 19.4372 0.157712 14.7354 2.31308 10.6522C4.46844 6.56898 7.97044 3.35541 12.226 1.5557C17.1178 -0.48929 22.6216 -0.513992 27.5316 1.48701C32.4416 3.48801 36.3573 7.35153 38.4208 12.231C40.4842 17.1105 40.5272 22.6081 38.5401 27.5192C36.5531 32.4302 32.6982 36.3543 27.82 38.4315C25.3532 39.4744 22.701 40.0092 20.0224 40.0039ZM12.6176 19.9942L10.8127 21.7964L17.2489 28.2253L30.2969 15.1926L28.4876 13.3904L17.2437 24.6216L12.6176 19.9942Z",
    fill: "#00C1AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/Icon-success.f81770d7.svg";
export { ForwardRef as ReactComponent };